import { contentHeight } from '../../common/directives/layout';

const SPACING = 50;

export function timelineWeaveLayout(elements, container) {
  if (contentHeight(container) === 0) {
    return;
  }

  elements.reduce(
    ({ totals }, el, index, { length }) => {
      // CSS uses 1-based indexing. Mimic for consistency.
      const isEven = (index + 1) % 2 === 0;

      const elHeight = contentHeight(el);
      const currentColHeight = isEven ? totals.even : totals.odd;
      const oppositeColHeight = isEven ? totals.odd : totals.even;
      const currentColMin = currentColHeight + elHeight;
      const oppositeColMin = oppositeColHeight + SPACING;

      const offset = Math.max(
        Math.round(oppositeColMin - currentColMin),
        Math.round(SPACING - elHeight)
      );

      let cssText = [];

      if (index === 0) {
        cssText.push(`padding-top: ${SPACING}px`);
      }

      if (index === length - 1) {
        cssText.push(`padding-bottom: ${Math.max(SPACING, offset)}px`);
      } else {
        cssText.push(
          `${offset > 0 ? 'padding' : 'margin'}-bottom: ${offset}px`
        );
      }

      cssText.push(`margin-${isEven ? 'left' : 'right'}: 50%;`);
      cssText.push(`margin-${isEven ? 'right' : 'left'}: auto;`);

      el.style.cssText = cssText.join('; ');

      const newHeight = currentColMin + Math.max(0, offset);

      return {
        totals: {
          odd: isEven ? oppositeColMin : newHeight,
          even: isEven ? newHeight : oppositeColMin,
        },
      };
    },
    {
      totals: {
        odd: 0,
        even: SPACING, // Accounts for `padding-top` of initial item.
      },
    }
  );
}
